import * as colors from './baseColors';

/**
 *  Color values for agGrid theme.
 *  Colors are specified as CSS custom properties. They are injected with our CSS baseline
 *  and scoped to .ag-theme-tock.  All properties are included on our Mui theme object under the
 *  key "colors.agGrid"
 *
 *  '--ag' prefixed properties are consumed by the ag-grid theme
 *  '--ag-tock' prefixed properties are utilized for row/cell styling functions
 */
export const globalLightColors = {
  // Ag Grid theme colors
  '--ag-foreground-color': colors.slateDark,
  '--ag-background-color': colors.white,
  '--ag-border-color': colors.grayDark,
  '--ag-data-color': colors.slateDark,
  '--ag-header-cell-hover-background-color': 'transparent',
  '--ag-header-column-resize-handle-color': '#B1BAC9',
  '--ag-header-foreground-color': colors.slateDark,
  '--ag-header-background-color': colors.grayLight,
  '--ag-range-selection-border-color': colors.royalBase,
  '--ag-row-hover-color': 'transparent',
  '--ag-secondary-foreground-color': colors.slateDark,
  '--ag-disabled-foreground-color': colors.grayDarker,
  '--ag-checkbox-checked-color': colors.royalBase,
  '--ag-selected-row-background-color': colors.grayBase,

  // Tock row/cell colors
  '--ag-tock-footer-background-color': colors.royalLighter,
};

export const agGridDarkColors = {
  // Ag Grid theme colors
  '--ag-foreground-color': colors.smokeLightest,
  '--ag-background-color': colors.chimneyDark,
  '--ag-border-color': colors.chimneyLightest,
  '--ag-data-color': colors.smokeLightest,
  '--ag-header-cell-hover-background-color': 'transparent',
  '--ag-header-column-resize-handle-color': '#828282',
  '--ag-header-foreground-color': colors.smokeLightest,
  '--ag-header-background-color': colors.chimneyLight,
  '--ag-range-selection-border-color': '#248FFF',
  '--ag-row-hover-color': 'transparent',
  '--ag-secondary-foreground-color': colors.smokeLightest,
  '--ag-disabled-foreground-color': colors.grayDarker,
  '--ag-checkbox-checked-color': colors.royalBase,
  '--ag-selected-row-background-color': colors.chimneyLighter,

  // Tock row/cell colors
  '--ag-tock-footer-background-color': colors.chimneyLight,
};

export interface AgGridColors {
  foregroundColor: string;
  backgroundColor: string;
  borderColor: string;
  dataColor: string;
  headerCellHoverBackgroundColor: string;
  headerForegroundColor: string;
  headerBackgroundColor: string;
  rangeSelectionBorderColor: string;
  rowHoverColor: string;
  secondaryForegroundColor: string;
  disabledForegroundColor: string;
  footerBackgroundColor: string;
  checkboxCheckedColor: string;
  selectedRowBackgroundColor: string;
}

export const agGridColors: AgGridColors = {
  foregroundColor: 'var(--ag-foreground-color)',
  backgroundColor: 'var(--ag-background-color)',
  borderColor: 'var(--ag-border-color)',
  dataColor: 'var(--ag-data-color)',
  headerCellHoverBackgroundColor: 'var(--ag-header-cell-hover-background-color)',
  headerForegroundColor: 'var(--ag-header-foreground-color)',
  headerBackgroundColor: 'var(--ag-header-background-color)',
  rangeSelectionBorderColor: 'var(--ag-range-selection-border-color)',
  rowHoverColor: 'var(--ag-row-hover-color)',
  secondaryForegroundColor: 'var(--ag-secondary-foreground-color)',
  disabledForegroundColor: 'var(--ag-foreground-color)',
  checkboxCheckedColor: 'var(--ag-checkbox-checked-color)',
  selectedRowBackgroundColor: 'var(--ag-selected-row-background-color)',

  footerBackgroundColor: 'var(--ag-tock-footer-background-color)',
};
